
// Copyright 2002-2013, University of Colorado Boulder

/**
 * This model implementation tracks the location of the pointer(s), if any, so they can be visualized during playback.
 *
 * @author Sam Reid (PhET Interactive Simulations)
 */
define( 'JOIST/share/Pointer',['require'],function( require ) {
  'use strict';

  function Pointer() {}

  return Pointer;
} );